<template>
  <div class="mod-order-execution">
    <el-form class="execution-filters" :inline="true" :model="query" @keyup.enter.native="pageIndex = 1; loadData()">
      <el-form-item label="销售订单"><el-input v-model="query.orderCode" size="small" clearable style="width:130px" /></el-form-item>
      <el-form-item label="客户"><el-input v-model="query.partnerName" size="small" clearable style="width:130px" /></el-form-item>
      <el-form-item label="物料编码"><el-input v-model="query.materialCode" size="small" clearable style="width:110px" /></el-form-item>
      <el-form-item label="执行状态">
        <el-select v-model="query.executionFilter" size="small" style="width:130px">
          <el-option label="全部" value="all" />
          <el-option label="全部待办" value="all_open" />
          <el-option label="已订未出" value="open_stock" />
          <el-option label="生产中" value="open_production" />
          <el-option label="已出未结" value="open_finance" />
          <el-option label="已退可结" value="open_return_settle" />
        </el-select>
      </el-form-item>
      <el-form-item label="订单日期" class="date-filter">
        <el-date-picker v-model="query.orderDateStart" type="date" value-format="yyyy-MM-dd" size="small" style="width:108px" placeholder="起" />
        <span class="date-separator">-</span>
        <el-date-picker v-model="query.orderDateEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width:108px" placeholder="止" />
        <el-button class="search-button" type="primary" size="small" @click="pageIndex = 1; loadData()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" border v-loading="loading" show-summary :summary-method="getSummaries" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
      <el-table-column type="index" label="序号" width="55" align="center" fixed="left" />
      <el-table-column prop="orderCode" label="销售订单" width="120" fixed="left" />
      <el-table-column prop="orderDate" label="订单日期" width="105" align="center">
        <template slot-scope="scope">{{ (scope.row.orderDate || '').slice(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="partnerName" label="客户" min-width="120" />
      <el-table-column prop="materialCode" label="物料编码" width="110" />
      <el-table-column prop="materialName" label="物料名称" min-width="120" />
      <el-table-column prop="orderQuantity" label="订单量" width="90" align="right" />
      <el-table-column prop="noticedQuantity" label="已通知" width="90" align="right" />
      <el-table-column prop="remainShippingNoticeQuantity" label="可通知" width="90" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.remainShippingNoticeQuantity) > 0 }">{{ scope.row.remainShippingNoticeQuantity }}</span></template>
      </el-table-column>
      <el-table-column prop="fulfilledQuantity" label="已出库" width="90" align="right" />
      <el-table-column prop="returnedQuantity" label="已退货" width="90" align="right" />
      <el-table-column prop="pendingStockQuantity" label="待审出库" width="90" align="right" />
      <el-table-column prop="remainStockQuantity" label="可出库" width="100" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.remainStockQuantity) > 0 }">{{ scope.row.remainStockQuantity }}</span></template>
      </el-table-column>
      <el-table-column prop="productionAllocatedQty" label="已下推" width="80" align="right" />
      <el-table-column prop="productionReceivedQty" label="已完工" width="80" align="right" />
      <el-table-column prop="productionInProgressQty" label="生产中" width="80" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.productionInProgressQty) > 0 }">{{ scope.row.productionInProgressQty }}</span></template>
      </el-table-column>
      <el-table-column prop="postedFinanceQuantity" label="已挂账" width="90" align="right" />
      <el-table-column prop="remainFinanceQuantity" label="可挂账" width="100" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.remainFinanceQuantity) > 0 }">{{ scope.row.remainFinanceQuantity }}</span></template>
      </el-table-column>
      <el-table-column prop="remainSettleAmount" label="未收款" width="110" align="right">
        <template slot="header"><span title="含应收未收款；发票未收款按发票行金额比例分配到订单行">未收款</span></template>
      </el-table-column>
      <el-table-column prop="remainReturnSettleQuantity" label="退结余量" width="90" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.remainReturnSettleQuantity) > 0 }">{{ scope.row.remainReturnSettleQuantity }}</span></template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="70" align="center">
        <template slot-scope="scope"><el-button type="text" size="small" @click="openTrace(scope.row)">追溯</el-button></template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="val => { pageSize = val; pageIndex = 1; loadData() }"
      @current-change="val => { pageIndex = val; loadData() }"
      :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper" style="margin-top:12px"
    />
    <sales-order-trace-dialog :visible.sync="traceVisible" :order-line-id="traceOrderLineId" />
  </div>
</template>

<script>
import SalesOrderTraceDialog from '../../components/sales-order-trace-dialog/index.vue'
import request from '../../api/request'

export default {
  name: 'SalesOrderExecution',
  components: { SalesOrderTraceDialog },
  data() {
    return {
      query: { orderCode: '', partnerName: '', materialCode: '', executionFilter: 'all_open', orderDateStart: '', orderDateEnd: '' },
      dataList: [], loading: false, pageIndex: 1, pageSize: 20, totalPage: 0, traceVisible: false, traceOrderLineId: ''
    }
  },
  created() { this.loadData() },
  activated() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      request.post('/sale/salesOrderExecution/list', {
        currentPage: this.pageIndex, pageSize: this.pageSize,
        code: this.query.orderCode, partnerName: this.query.partnerName, customerName: this.query.partnerName,
        materialCode: this.query.materialCode, executionFilter: this.query.executionFilter,
        dateFrom: this.query.orderDateStart, dateTo: this.query.orderDateEnd
      }).then(res => {
        const body = res.data || {}
        this.dataList = (body.list || []).map(row => ({
          orderLineId: row.salesOrderLineId,
          orderCode: row.salesOrderCode,
          orderDate: row.orderDate,
          partnerName: row.customerName,
          materialCode: row.materialCode,
          materialName: row.materialName,
          orderQuantity: row.quantity,
          noticedQuantity: row.noticedQuantity,
          remainShippingNoticeQuantity: row.remainShippingNoticeQuantity,
          fulfilledQuantity: row.shippedQuantity,
          returnedQuantity: row.returnedQuantity,
          pendingStockQuantity: row.pendingStockOutQuantity,
          remainStockQuantity: row.remainStockQuantity,
          productionAllocatedQty: row.productionAllocatedQty,
          productionReceivedQty: row.productionReceivedQty,
          productionInProgressQty: row.productionInProgressQty,
          postedFinanceQuantity: row.receivablePostedQuantity,
          remainFinanceQuantity: row.remainReceivableQuantity,
          remainSettleAmount: row.remainReceiptAmount,
          remainReturnSettleQuantity: row.remainReturnSettleQuantity
        }))
        this.totalPage = body.totalCount || 0
      }).catch(err => {
        this.dataList = []
        this.totalPage = 0
        this.$message.error((err && err.message) || '加载销售执行看板失败')
      }).finally(() => { this.loading = false })
    },
    openTrace(row) {
      if (!row.orderLineId) return
      this.traceOrderLineId = row.orderLineId
      this.traceVisible = true
    },
    getSummaries({ columns, data }) {
      const sums = []
      const sumFields = ['orderQuantity', 'noticedQuantity', 'remainShippingNoticeQuantity', 'fulfilledQuantity', 'returnedQuantity', 'remainStockQuantity', 'productionInProgressQty', 'remainFinanceQuantity', 'remainSettleAmount']
      columns.forEach((col, index) => {
        if (index === 0) { sums[index] = '合计'; return }
        if (sumFields.indexOf(col.property) < 0) { sums[index] = ''; return }
        const total = data.reduce((s, r) => s + Number(r[col.property] || 0), 0)
        sums[index] = total.toFixed(3)
      })
      return sums
    }
  }
}
</script>

<style scoped>
.execution-filters { display: flex; flex-wrap: wrap; gap: 8px 16px; align-items: center; margin-bottom: 12px; }
.execution-filters >>> .el-form-item { display: flex; align-items: center; margin: 0; }
.execution-filters >>> .date-filter .el-form-item__content { display: flex; align-items: center; white-space: nowrap; }
.date-separator { margin: 0 6px; }
.search-button { margin-left: 10px; }
.text-warn { color: #e6a23c; font-weight: 600; }
</style>
